import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import de from './locales/de.json';

const i18n = createI18n({
  // default locale
  locale: 'en-US',
  fallbackLocale: 'en-US',
  legacy: false,
  // translations
  messages: {
    'en-US': en,
    'de-DE': de,
  },
});

export default i18n;
